// Country and language selector
class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.elements.button.addEventListener('click', this.handleButtonClick);
        this.elements.button.addEventListener('touchstart', this.handleButtonClick);
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        let isScrolling = false;
        let touchStartX = 0;
        let touchStartY = 0;
        let scrollTimeout;

        const SCROLL_THRESHOLD = 10; // Adjust the threshold as needed

        window.addEventListener('scroll', () => {
            isScrolling = true;
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                isScrolling = false;
            }, 100); // Adjust the timeout as needed
        });

        this.querySelectorAll('a').forEach(item => {
            item.addEventListener('touchstart', event => {
                touchStartX = event.touches[0].clientX;
                touchStartY = event.touches[0].clientY;
            });

            item.addEventListener('touchend', event => {
                const touchEndX = event.changedTouches[0].clientX;
                const touchEndY = event.changedTouches[0].clientY;
                const distanceX = Math.abs(touchEndX - touchStartX);
                const distanceY = Math.abs(touchEndY - touchStartY);

                if (distanceX < SCROLL_THRESHOLD && distanceY < SCROLL_THRESHOLD && !isScrolling) {
                    this.handleItemClick(event);
                } else {
                    event.preventDefault();
                }
            });

            item.addEventListener('click', event => {
                if (isScrolling) {
                    event.preventDefault();
                    return;
                }
                this.handleItemClick(event);
            });
        });
    }

    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
    }

    handleItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
        this.hidePanel();
    }

    handleButtonClick(event) {
        event.preventDefault();
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', (!isExpanded).toString());
    }

    closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
            this.hidePanel();
        }
    }
}

customElements.define('localization-form', LocalizationForm);

class CookieManager {
    // Function to set a cookie
    static setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || "")}${expires}; path=/; SameSite=Lax`;
    }

    // Function to get a cookie
    static getCookie(name) {
        const nameEQ = `${encodeURIComponent(name)}=`;
        const ca = document.cookie.split(';');
        for (let c of ca) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
        }
        return null;
    }

    // Function to delete a cookie
    static deleteCookie(name) {
        document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
    }
}

// Modal
document.addEventListener('DOMContentLoaded', async () => {

    let countryName = '';

    try {
        const localizationData = await themeObject.fetchLocalization();
        if (localizationData && localizationData.detected_values && localizationData.detected_values.country_name) {
            countryName = localizationData.detected_values.country_name;
        }
    } catch (error) {
        console.error('Error fetching localization data:', error);
    }

    const closeButtons = document.querySelectorAll('.modal__close');
    const modal = document.getElementById('localization-modal');
    const backdrop = document.querySelector('.modal__backdrop');
    const openModalButton = document.querySelector('.button-modal');

    const hideModalAndBackdrop = () => {
        modal.setAttribute('hidden', 'true');
        backdrop.setAttribute('hidden', 'true');
        CookieManager.setCookie('localizationModal', 'true', 14);
    };

    const showModalAndBackdrop = () => {
        modal.removeAttribute('hidden');
        backdrop.removeAttribute('hidden');
        CookieManager.deleteCookie('localizationModal');
    };

    if (countryName === 'United States') {
        modal.setAttribute('hidden', 'true');
        backdrop.setAttribute('hidden', 'true');
    } else if (CookieManager.getCookie('localizationModal') === 'true') {
        modal.setAttribute('hidden', 'true');
        backdrop.setAttribute('hidden', 'true');
    } else {
        setTimeout(() => {
            modal.removeAttribute('hidden');
            backdrop.removeAttribute('hidden');
            CookieManager.setCookie('localizationModal', 'true', 14);
        }, 2000);
    }

    closeButtons.forEach(button => {
        button.addEventListener('click', hideModalAndBackdrop);
    });

    if (openModalButton) {
        openModalButton.addEventListener('click', showModalAndBackdrop);
    }
});

// Function to toggle modal elements
const toggleModalElements = () => {
    const modalSwitchers = document.querySelector('.modal__switchers');
    const cancelSpan = document.querySelector('.modal__cancel');
    const selectLangSpan = document.querySelector('.modal__select-lang');
    const modalBody = document.querySelector('.modal__body');

    // Toggle hidden attribute for modalSwitchers, cancelSpan, and selectLangSpan
    modalSwitchers.toggleAttribute('hidden');
    cancelSpan.toggleAttribute('hidden');
    selectLangSpan.toggleAttribute('hidden');

    // Toggle hidden attribute for modalBody based on its current state
    modalBody.toggleAttribute('hidden');
};

// Event listener for the ".modal__select-lang" span
const selectLangSpan = document.querySelector('.modal__select-lang');
if (selectLangSpan) {
    selectLangSpan.addEventListener('click', toggleModalElements);
    selectLangSpan.addEventListener('touchstart', toggleModalElements);
}

// Event listener for the ".modal__cancel" span
const cancelSpan = document.querySelector('.modal__cancel');
if (cancelSpan) {
    cancelSpan.addEventListener('click', toggleModalElements);
    cancelSpan.addEventListener('touchstart', toggleModalElements);
}
